import React, { Component } from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Grid from '@mui/material/Grid';
import { SHOW_ENR } from '@lba-dev/package.local-globals/configTypes';

import CallLogs from './CallLogs';
import { cacheDisabled } from '../../utils/function';

class CallLogInter extends Component {
  state = { tab: 0 }

  handleChangeTab = (event, tab) => this.setState({ tab });

  render() {
    const { sm, numbers, itemId } = this.props;
    const { tab } = this.state;
    return !cacheDisabled(SHOW_ENR) && (
      <Grid item xs={12} sm={sm || 4}>
        <Tabs
          value={tab}
          onChange={this.handleChangeTab}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab label="JOURNAL D'APPELS ENTRANT" />
          <Tab label="JOURNAL D'APPELS SORTANT" />
        </Tabs>
        <CallLogs
          itemId={itemId}
          source="intervention"
          keyUrl="inter"
          numbers={numbers}
          direction={!tab ? 'inbound' : 'outbound'}
        />
      </Grid>
    );
  }

}


export default CallLogInter;
